// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39nEI","label":"styles_label__2fH6n"};